import { defineMessages } from 'react-intl-next';

export default defineMessages({
	// BITBUCKET_PULL_REQUESTS
	bitbucketPullRequestsPrompt1: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-1',
		defaultMessage: 'Summarize this pull request.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt2: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-2',
		defaultMessage: 'Explain the code changes to me.',
		description:
			'The second prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt3: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-3',
		defaultMessage: 'Summarize the comments on this pull request.',
		description:
			'The third prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	// BITBUCKET_REPOSITORY_SOURCE
	bitbucketRepositorySourcePrompt1: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-1',
		defaultMessage: 'Explain this file.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt2: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-2',
		defaultMessage: 'What are the pull requests authored by `person`?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt3: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-3',
		defaultMessage: ' What APIs or modules do these files interact with?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	// BITBUCKET_HOME
	bitbucketPrompt1: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-prompt-1',
		defaultMessage: 'What are the pull requests authored by `person`?',
		description:
			'The first prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt2: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-prompt-2',
		defaultMessage: 'What are the open PRs for the current Jira sprint?',
		description:
			'The second prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt3: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-prompt-3',
		defaultMessage: 'Has `Jira work item` been deployed?',
		description:
			'The third prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt4: {
		id: 'ai-mate.chat-history.empty-state.bitbucket-prompt-4',
		defaultMessage: 'Who are the reviewers on this `Pull request`?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	// CONFLUENCE_HOME
	confluenceHomePrompt1: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-1',
		defaultMessage: "Is there any new activity on pages I've written?",
		description:
			'The first prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt2: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-2',
		defaultMessage: 'Are there any new comments mentioning me?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt3: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-3',
		defaultMessage: 'Summarize the most recently published pages in this space.',
		description:
			'The third prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt4: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-4',
		defaultMessage: 'Summarize my contributions to pages from last week.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt5: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-5',
		defaultMessage: 'Can you take this `page` and write it in a less technical way?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt6: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-6',
		defaultMessage: 'Create a game plan template for project management.',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt7: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-7',
		defaultMessage: 'What research do we have on common customer problems?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt8: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-8',
		defaultMessage: 'Has anyone on my team published any new pages this week?',
		description:
			'The eighth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt9: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-9',
		defaultMessage: 'Has `person` published any new pages this week?',
		description:
			'The ninth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt10: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-10',
		defaultMessage: "Has `person` commented on any pages that I've published?",
		description:
			'The tenth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt11: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-11',
		defaultMessage: 'What are the key takeaways from `page`?',
		description:
			'The eleventh prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt12: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-prompt-12',
		defaultMessage: 'What should I work on next?',
		description:
			'The twelfth prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	// CONFLUENCE_PAGE_VIEW
	confluencePageViewPrompt1: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1',
		defaultMessage: "Summarize what I'm looking at.",
		description:
			'The first prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt2: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2',
		defaultMessage: 'Summarize the comments on this page.',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt3: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3',
		defaultMessage: "Explain this page to me like I'm a beginner.",
		description:
			'The third prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt4: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4',
		defaultMessage: 'Who wrote this page and what team are they on?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt5: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5',
		defaultMessage: 'Has anything on this page changed in the last week?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt6: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-view-prompt-6',
		defaultMessage: 'What should I work on next?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	// CONFLUENCE_PAGE_EDIT
	confluencePageEditPrompt1: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1',
		defaultMessage: 'Can you improve the writing on this page?',
		description:
			'The first prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt2: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2',
		defaultMessage: 'Write an executive summary for this page.',
		description:
			'The second prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt3: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3',
		defaultMessage: 'Give me links to some other relevant pages.',
		description:
			'The third prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt4: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when editing a Confluence page',
	},
	// CONFLUENCE_WHITEBOARD
	confluenceWhiteboardPrompt1: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1',
		defaultMessage: "Summarize what I'm looking at.",
		description:
			'The first prompt option in the empty state of the chat history when viewing a Confluence whiteboard',
	},
	confluenceWhiteboardPrompt2: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2',
		defaultMessage: 'Highlight any patterns or trends visible here.',
		description:
			'The second prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.',
	},
	confluenceWhiteboardPrompt3: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3',
		defaultMessage: 'Identify any key action items or decisions captured in this whiteboard.',
		description:
			'The third prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.',
	},
	confluenceWhiteboardPrompt4: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Confluence whiteboard',
	},
	// JIRA_HOME
	jiraHomePrompt1: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-1',
		defaultMessage: 'Find Jira work items that have been updated this week.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt2: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-2',
		defaultMessage: 'What Jira work items are the highest priority?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt3: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-3',
		defaultMessage: 'What Jira work items have comments mentioning me?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt4: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-4',
		defaultMessage: 'Summarize the comments on `Jira work item`.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt5: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-5',
		defaultMessage: 'Create a description template for user stories.',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt6: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-6',
		defaultMessage: 'What should I work on next?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	// JIRA_ISSUE_VIEW
	jiraIssueViewPrompt1: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1',
		defaultMessage: 'Are there any similar Jira work items to this one?',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira work item',
	},
	jiraIssueViewPrompt2: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2',
		defaultMessage: 'How could I improve the description?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira work item',
	},
	jiraIssueViewPrompt3: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3',
		defaultMessage: 'What labels could I add to this work item?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira work item',
	},
	jiraIssueViewPrompt4: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira work item',
	},
	// JIRA PROJECT
	jiraProjectPrompt1: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-1',
		defaultMessage: 'What work hasn’t been picked up in a while?',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt2: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-2',
		defaultMessage: 'Are any Jira work items blocked?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt3: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-3',
		defaultMessage:
			'List Jira work items that are currently “In Progress” and group them by assignee.',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt4: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-4',
		defaultMessage: 'How many work items are assigned to `person`?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt5: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-5',
		defaultMessage: 'Has `person` commented on any Jira work items in this sprint?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt6: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-6',
		defaultMessage: 'What Jira work items are unassigned?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt7: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-7',
		defaultMessage: 'What Jira work items have been open the longest?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt8: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-8',
		defaultMessage: 'Who has the most tasks?',
		description:
			'The eighth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt9: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-10',
		defaultMessage: 'Find and group similar Jira work items.',
		description:
			'The tenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt10: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-11',
		defaultMessage: 'Are there any Jira work items not connected to a parent work item?',
		description:
			'The eleventh prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt11: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-12',
		defaultMessage: 'Take `Jira work item` description and align it to best-practice.',
		description:
			'The twelfth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt12: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-13',
		defaultMessage: 'Summarize the comments on `Jira work item`.',
		description:
			'The thirteenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt13: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-14',
		defaultMessage: 'Create a description template for user stories.',
		description:
			'The fourteenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt14: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-15',
		defaultMessage: 'What should I work on next?',
		description:
			'The fifteenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	// ATLAS HOME
	atlasHomePrompt1: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-1',
		defaultMessage: 'What Confluence pages have I contributed to recently?',
		description:
			'The first prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt2: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-2',
		defaultMessage: 'Find all Jira tickets that are assigned to me.',
		description:
			'The second prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt3: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-3',
		defaultMessage: 'What is our travel policy?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt4: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-4',
		defaultMessage: 'Draft a Confluence page for a marketing campaign.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt5: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-5',
		defaultMessage: 'How can I create a project timeline?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt6: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-6',
		defaultMessage: 'Write a follow up email to potential clients.',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt7: {
		id: 'ai-mate.chat-history.empty-state.atlas-home-prompt-7',
		defaultMessage: 'What should I work on next?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	// UNKNOWN
	unknownPrompt1: {
		id: 'ai-mate.chat-history.empty-state.suggestion1',
		defaultMessage: 'Are any of my work items overdue?',
		description: 'The first suggestion displayed in the empty state of the chat history',
	},
	unknownPrompt2: {
		id: 'ai-mate.chat-history.empty-state.suggestion2',
		defaultMessage: 'What should I work on next?',
		description: 'The second suggestion displayed in the empty state of the chat history',
	},
	unknownPrompt3: {
		id: 'ai-mate.chat-history.empty-state.suggestion3',
		defaultMessage: 'Write an update about my week',
		description: 'The third suggestion displayed in the empty state of the chat history',
	},

	// LLM LABELS

	// CONFLUENCE_HOME
	confluenceHomeLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-llm-label-1',
		defaultMessage: 'About this space',
		description: 'Label 1 for the llm generated starter when viewing Confluence Home',
	},
	confluenceHomeLLMLabel2: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-llm-label-2',
		defaultMessage: 'Insights on this space',
		description: 'Label 2 for the llm generated starter when viewing Confluence Home',
	},
	confluenceHomeLLMLabel3: {
		id: 'ai-mate.chat-history.empty-state.confluence-home-llm-label-3',
		defaultMessage: 'Space suggestion',
		description: 'Label 3 for the llm generated starter when viewing Confluence Home',
	},
	// CONFLUENCE_PAGE_VIEW
	confluencePageLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-llm-label-1',
		defaultMessage: 'About this page',
		description: 'Label 1 for the llm generated starter when viewing a Confluence page',
	},
	confluencePageLLMLabel2: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-llm-label-2',
		defaultMessage: 'More from this page',
		description: 'Label 2 for the llm generated starter when viewing a Confluence page',
	},
	confluencePageLLMLabel3: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-llm-label-3',
		defaultMessage: 'Insights on this page',
		description: 'Label 3 for the llm generated starter when viewing a Confluence page',
	},
	confluencePageLLMLabel4: {
		id: 'ai-mate.chat-history.empty-state.confluence-page-llm-label-3',
		defaultMessage: 'Page suggestion',
		description: 'Label 4 for the llm generated starter when viewing a Confluence page',
	},
	// CONFLUENCE_WHITEBOARD
	confluenceWhiteboardLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1',
		defaultMessage: 'About this whiteboard',
		description: 'Label 1 for the llm generated starter when viewing a Confluence whiteboard',
	},
	confluenceWhiteboardLLMLabel2: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2',
		defaultMessage: 'More from this whiteboard',
		description: 'Label 2 for the llm generated starter when viewing a Confluence whiteboard',
	},
	confluenceWhiteboardLLMLabel3: {
		id: 'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3',
		defaultMessage: 'Insights on this whiteboard',
		description: 'Label 3 for the llm generated starter when viewing a Confluence whiteboard',
	},
	// JIRA ISSUE VIEW
	jiraIssueLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-1',
		defaultMessage: 'About this work item',
		description: 'Label 1 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel2: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-2',
		defaultMessage: 'More from this work item',
		description: 'Label 2 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel3: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-3',
		defaultMessage: 'Insights on this work item',
		description: 'Label 3 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel4: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-4',
		defaultMessage: 'Work item suggestion',
		description: 'Label 4 for the llm generated starter when viewing Jira work item',
	},
	// JIRA PROJECT
	jiraProjectLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.jira-project-llm-label-1',
		defaultMessage: 'About this project',
		description: 'Label 1 for the llm generated starter when viewing Jira Project',
	},
	jiraProjectLLMLabel2: {
		id: 'ai-mate.chat-history.empty-state.jira-project-llm-label-2',
		defaultMessage: 'Insights on this project',
		description: 'Label 2 for the llm generated starter when viewing Jira Project',
	},
	jiraProjectLLMLabel3: {
		id: 'ai-mate.chat-history.empty-state.jira-project-llm-label-3',
		defaultMessage: 'More from this project',
		description: 'Label 3 for the llm generated starter when viewing Jira Project',
	},
	jiraProjectLLMLabel4: {
		id: 'ai-mate.chat-history.empty-state.jira-project-llm-label-4',
		defaultMessage: 'Project suggestion',
		description: 'Label 4 for the llm generated starter when viewing Jira Project',
	},
	// UNKNOWN
	unknownLLMLabel1: {
		id: 'ai-mate.chat-history.empty-state.unknown-llm-label-1',
		defaultMessage: 'Suggestion',
		description: 'Label 1 for the llm generated starter when viewing an unknown page',
	},
	jiraHomePrompt1IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh',
		defaultMessage: 'Find Jira work items that have been updated this week.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt2IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh',
		defaultMessage: 'What Jira work items are the highest priority?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt3IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh',
		defaultMessage: 'What Jira work items have comments mentioning me?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt4IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh',
		defaultMessage: 'Summarize the comments on `Jira work item`.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraIssueViewPrompt1IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh',
		defaultMessage: 'Are there any similar Jira work items to this one?',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira work item',
	},
	jiraIssueViewPrompt3IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh',
		defaultMessage: 'What labels could I add to this work item?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira work item',
	},
	jiraProjectPrompt2IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh',
		defaultMessage: 'Are any Jira work items blocked?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt3IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh',
		defaultMessage:
			'List Jira work items that are currently “In Progress” and group them by assignee.',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt4IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh',
		defaultMessage: 'How many work items are assigned to `person`?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt5IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh',
		defaultMessage: 'Has `person` commented on any Jira work items in this sprint?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt6IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh',
		defaultMessage: 'What Jira work items are unassigned?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt7IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh',
		defaultMessage: 'What Jira work items have been open the longest?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt9IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh',
		defaultMessage: 'Find and group similar Jira work items.',
		description:
			'The tenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt10IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh',
		defaultMessage: 'Are there any Jira work items not connected to a parent work item?',
		description:
			'The eleventh prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt11IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh',
		defaultMessage: 'Take `Jira work item` description and align it to best-practice.',
		description:
			'The twelfth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt12IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh',
		defaultMessage: 'Summarize the comments on `Jira work item`.',
		description:
			'The thirteenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraProjectPrompt13IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh',
		defaultMessage: 'Create a description template for user stories.',
		description:
			'The fourteenth prompt option in the empty state of the chat history when viewing Jira Project',
	},
	jiraIssueLLMLabel1IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh',
		defaultMessage: 'About this work item',
		description: 'Label 1 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel2IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh',
		defaultMessage: 'More from this work item',
		description: 'Label 2 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel3IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh',
		defaultMessage: 'Insights on this work item',
		description: 'Label 3 for the llm generated starter when viewing Jira work item',
	},
	jiraIssueLLMLabel4IssueTermRefresh: {
		id: 'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh',
		defaultMessage: 'Work item suggestion',
		description: 'Label 4 for the llm generated starter when viewing Jira work item',
	},
} as const);
